module.exports = __webpack_public_path__ + "static/media/powered-by-finkraft-light-text.5580f4c4.svg";